import { SubLayout } from 'layout';
import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export function Community({ setRef, langList }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/community') {
      navigate('/community/notice');
    }
  }, []);

  return (
    <SubLayout setRef={setRef} list={langList.notice} nav={langList.nav}>
      <Outlet context={{ setRef, langList }} />
    </SubLayout>
  );
}
